/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endtime1Inputs */

const en__field_endtime1 = /** @type {(inputs: _Field_Endtime1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End time`)
};

/**
* | output |
* | --- |
* | "End time" |
*
* @param {_Field_Endtime1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_endtime1 = /** @type {((inputs?: _Field_Endtime1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endtime1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_endtime1(inputs)
});
export { _field_endtime1 as "_field_endTime" }